<!-- <div class="frame-container">
  <app-iframe title="Apache Superset" [url]="url"></app-iframe>
</div> -->
<div class="button-container">
  <xg-button
    icon="cloud_sync"
    text="Resync Data"
    buttonColor="primary"
    buttonType="raised"
    [matTooltip]="'Resync Data'"
    (click)="resyncMsData()"
  ></xg-button>
</div>
<div class="frame-container">
  <app-iframe title="Apache Superset" [url]="url"></app-iframe>
</div>
